
































































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IWebhook } from "@/models/webhooks";

@Component({
  components: {
    "webhook-triggers-listing": () =>
      import(
        "@/components/app/admin/settings/webhooks/webhookTriggersListing.vue"
      ),
    "webhook-triggers-provider": () =>
      import(
        "@/components/app/admin/settings/webhooks/webhookTriggersProvider.vue"
      )
  }
})
export default class WebhookTriggersComp extends Vue {
  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise", "div"].includes(tag)
  })
  public readonly tag!: string;

  @Prop({ default: false })
  public webhookId!: IWebhook["id"];
}
